<template>
    <v-container class="pt-1 pb-12 py-sm-12 px-4 px-sm-0">
       <v-row class="d-none d-sm-flex">
    <v-col :cols="12">
      <div class="title-container d-flex justify-space-between align-center">
    <div class="title-block">
        <div class="d-flex align-center ga-3">
            <span class="page-title">{{ page.title }}</span>
            <v-menu offset-y transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn small color="primary" text v-bind="attrs" v-on="on">
                        <v-icon left>mdi-help-circle-outline</v-icon>Ajuda
                    </v-btn>
                </template>
                <v-card min-width="380px">
                    <v-card-title class="text-h6 font-weight-bold pb-2">
                        <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-3 pb-3">
                        <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔖 Identificador</p><p class="text-caption grey--text">Número único que identifica este totem no sistema</p></div>
                        <v-divider class="my-2"></v-divider>
                        <div class="mb-3"><p class="font-weight-bold text-caption mb-1">✅ Status</p><p class="text-caption grey--text">Habilitado = totem funcionando. Desabilitado = fora de serviço</p></div>
                        <v-divider class="my-2"></v-divider>
                        <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔢 Versão</p><p class="text-caption grey--text">Versão do app instalado neste totem</p></div>
                        <v-divider class="my-2"></v-divider>
                        <div><p class="font-weight-bold text-caption mb-1">💳 Código Stone</p><p class="text-caption grey--text">Código da maquininha de pagamento vinculada a este totem</p></div>
                    </v-card-text>
                </v-card>
            </v-menu>
        </div>
        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
    </div>
    <div class="button-group">
        <v-btn id="btnBack" type="button" elevation="0" outlined exact style="color: #3BA5DB !important; border-color: #3BA5DB !important;" to="/totens">Voltar</v-btn>
        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
            :loading="dataset.loading">Salvar</v-btn>
    </div>
</div>
    </v-col>
</v-row>

<v-row class="d-sm-none d-lg-none d-md-flex">
    <v-col :cols="12">
        <div class="title-container">
            <div class="title-block">
                <div class="d-flex align-center">
                    <span class="page-title">{{ page.title }}</span>
                    <v-menu offset-y transition="slide-y-transition">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon small color="primary" class="ml-2" v-bind="attrs" v-on="on">
                                <v-icon>mdi-help-circle-outline</v-icon>
                            </v-btn>
                        </template>
                        <v-card min-width="320px">
                            <v-card-title class="text-h6 font-weight-bold pb-2">
                                <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="pt-3 pb-3">
                                <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔖 Identificador</p><p class="text-caption grey--text">Número único que identifica este totem no sistema</p></div>
                                <v-divider class="my-2"></v-divider>
                                <div class="mb-3"><p class="font-weight-bold text-caption mb-1">✅ Status</p><p class="text-caption grey--text">Habilitado = totem funcionando. Desabilitado = fora de serviço</p></div>
                                <v-divider class="my-2"></v-divider>
                                <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔢 Versão</p><p class="text-caption grey--text">Versão do app instalado neste totem</p></div>
                                <v-divider class="my-2"></v-divider>
                                <div><p class="font-weight-bold text-caption mb-1">💳 Código Stone</p><p class="text-caption grey--text">Código da maquininha de pagamento vinculada a este totem</p></div>
                            </v-card-text>
                        </v-card>
                    </v-menu>
                </div>
                <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
            </div>
        </div>
    </v-col>
</v-row>

<v-row class="d-sm-none d-lg-none d-md-flex">
    <v-col>
        <div class="button-group">
    <v-btn id="btnBack" type="button" elevation="0" outlined exact style="color: #3BA5DB !important; border-color: #3BA5DB !important;" to="/totens">Voltar</v-btn>
    <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
        :loading="dataset.loading">Salvar</v-btn>
</div>
    </v-col>
</v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field disabled dense label="Identificador"
                                                v-model="dataset.data.identificador" required :rules="[$rules.required]"
                                                outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-select dense :items="dataset.totemStatus" label="Status"
                                                v-model="dataset.data.habilitado" item-value="value" item-text="name"
                                                outlined :rules="[$rules.required]" required hide-details="auto">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field disabled dense label="Versão"
                                                v-model="dataset.data.versao" required outlined hide-details="auto"
                                                :rules="[$rules.required]">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                        <v-text-field dense label="Código Stone"
    v-model="dataset.data.stoneCode" required outlined hide-details="auto"
    :rules="[$rules.required]">
</v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-card :disabled="dataset.loading" class="card-form-outlined">
                        <v-card-title class="card-group-title">Ações</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                   <v-btn type="button" elevation="0" color="info" dark
    @click="restartTotem">Reiniciar totem</v-btn>
                                </v-col>
                                <!-- <v-col cols="12" sm="6">
                                            <v-select dense :items="dataset.machineTypes" label="Tipo de máquina"
                                                v-model="dataset.data.tipo" item-value="id" item-text="name" outlined
                                                :rules="[$rules.required]" required hide-details="auto">
                                            </v-select>
                                        </v-col> -->
                            </v-row>

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>
      <v-dialog v-model="dialogConfirmarStoneCode" max-width="480">
            <v-card>
                <v-card-title class="d-flex align-center" style="color: #dc3545;">
                    <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
                    Atenção
                </v-card-title>
                <v-card-text>
                    <v-alert type="error" text dense class="mb-0">
                        Ao alterar o stonecode você está alterando a conta de faturamento.
                    </v-alert>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn text color="primary" @click="confirmarUpdate">Confirma</v-btn>
                    <v-btn text @click="dialogConfirmarStoneCode = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import totemStatus from "@/common/data/totem-status.data"

import axios from "axios"

export default {
    name: "PaymentTotemDetails",

data: () => ({
        page: {
            title: "",
        },
        dataset: {
            data: {},
            breadcrumbItems: [],
            totemStatus: totemStatus,
            loading: false,
        },
        dataForm: {
            validForm: true,
        },
        dialogConfirmarStoneCode: false,
        stoneCodeOriginal: null,
    }),

    created() {
        this.loadData()
    },

    methods: {
        goBack() {
            this.$router.replace("/totens");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.load();
        },

        setPage() {
            this.page.title = `Detalhes do totem`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Listagem de totens",
                disabled: false,
                to: "/totens",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: `Detalhes do totem`,
                disabled: true,
                exact: true,
            });
        },

async load() {
            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/totem-pagamento/${this.$route.params.id}`);

                this.dataset.data = result.data
                this.stoneCodeOriginal = result.data.stoneCode;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.loading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            if (this.dataset.data.stoneCode !== this.stoneCodeOriginal) {
                this.dialogConfirmarStoneCode = true;
                return;
            }

            await this.salvarTotem();
        },

        async confirmarUpdate() {
            this.dialogConfirmarStoneCode = false;
            await this.salvarTotem(true);
        },
async salvarTotem(stoneCodeChanged = false) {
    this.dataset.loading = true;

    try {
             await axios.put(`/api/totem-pagamento/${this.$route.params.id}`, {
            identificador: this.dataset.data.identificador,
            habilitado: this.dataset.data.habilitado,
            versao: this.dataset.data.versao,
            stoneCode: this.dataset.data.stoneCode,
            operacaoId: this.dataset.data.operacao.id,
            aceitaVersaoBeta: this.dataset.data.aceitaVersaoBeta
        });

        this.stoneCodeOriginal = this.dataset.data.stoneCode;
        this.$dialog.notify.info("Totem atualizado com sucesso!", { position: "top-right", timeout: 2000 });

        if (stoneCodeChanged) {
            this.$dialog.notify.warning("É necessário reiniciar o totem para que as configurações tenham efeito.", { position: "top-right", timeout: 4000 });
        }

    } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
    } finally {
        this.dataset.loading = false;
    }
},
        async restartTotem() {

            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja reiniciar o totem?',
                title: 'Totem',
                actions: {
                    false: 'Cancelar',
                    true: 'Enviar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            try {
                await axios.post(`/api/totem-pagamento/${this.$route.params.id}/restart`, {});

                this.$dialog.notify.info("Comando para reiniciar o totem foi enviado com sucesso!", { position: "top-right", timeout: 2000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },
    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
.ga-3 { gap: 24px; }

/* O QUE FOI ADICIONADO: Ajuste exclusivo para os botões no Mobile */
@media (max-width: 768px) {
  .button-group {
    display: flex !important;
    width: 100% !important;
    gap: 12px !important;
    margin-top: 8px !important;
    margin-bottom: 16px !important;
  }

  .button-group .v-btn {
    flex: 1 !important;
    min-width: unset !important;
  }
}
</style>